export const TRANSLATIONS_JP_SETTINGS_CORE = {
  "settings.tab_google_integrations": "Google 連携",
  "settings.db_connection_title": "データベース接続",
  "settings.db_tables_title": "データベーステーブル",
  "settings.db_table_name": "テーブル名",
  "settings.db_send_selected": "選択したテーブルを送信",
  "settings.db_loading": "接続処理中...",
  "settings.db_connect_success": "データベースへの接続に成功しました。",
  "settings.db_connect_error": "データベースへの接続エラー。",
  "settings.db_not_configured": "データベース接続資格情報はまだ設定されていません。",
  "settings.db_send_success": "テーブルが正常に送信されました。",
  "settings.db_send_error": "テーブル送信エラー。",
  "settings.db_tables_error": "テーブル取得エラー。",
  "settings.db_table_connect_success": "テーブル接続に成功しました。",
  "settings.db_table_connect_error": "テーブル接続エラー。",
  "settings.cancel": "キャンセル",
  "settings.theme": "テーマ",
  "settings.language": "言語",
  "settings.light": "ライト",
  "settings.dark": "ダーク",
  "settings.spanish": "スペイン語",
  "settings.english": "英語",
  "settings.portuguese": "ポルトガル語",
  "settings.french": "フランス語",
  "settings.japanese": "日本語",
  "settings.title": "設定",
  "settings.customization": "カスタマイズ",
  "settings.company_logo": "会社ロゴ",
  "settings.logo_placeholder": "ここにロゴをアップロード",
  "settings.save": "保存",
  "settings.save_error": "設定の保存中にエラーが発生しました",
  "settings.db_type": "データベース種別",
  "settings.db_host": "ホスト",
  "settings.db_port": "ポート",
  "settings.db_user": "ユーザー",
  "settings.db_password": "パスワード",
  "settings.db_name": "データベース名",
  "settings.select_db_type": "選択...",
  "settings.tab_preferences": "設定",
  "settings.tab_bc_email_pooling": "BCメールプーリング",
  "settings.bc_title": "リンク済みBCメール",
  "settings.bc_create_btn": "BCメールを追加",
  "settings.bc_update_btn": "BCメールを更新",
  "settings.bc_create_success": "BCメールが正常にリンクされました。",
  "settings.bc_create_error": "BCメールのリンクに失敗しました。",
  "settings.bc_update_success": "BCメールが正常に更新されました。",
  "settings.bc_update_error": "BCメールの更新に失敗しました。",
  "settings.bc_not_configured": "このユーザーにはBC User Bindingが設定されていません。",
  "settings.whatsapp_not_configured": "WhatsApp番号はまだ設定されていません。",
  "settings.tab_email_oauth": "メール許可 (OAuth)",
  "settings.email_oauth_title": "メールプロバイダー接続許可 (OAuth)",
  "settings.email_oauth_placeholder":
    "近日中にGmail、Outlookなどのメールプロバイダーへのアクセスを許可できるようになります。",
  "settings.penalty_questions.tfidf_min": "TF-IDF最小値",
  "settings.penalty_questions.embedding_min": "埋め込み最小値",
  "settings.penalty_questions.tfidf_penalty": "TF-IDFペナルティ",
  "settings.penalty_questions.save": "ペナルティ設定を保存",
  "settings.penalty_questions.load_error": "ペナルティ設定の読み込みエラー。",
  "settings.penalty_questions.save_success":
    "ペナルティ設定が正常に保存されました。",
  "settings.penalty_questions.save_error": "ペナルティ設定の保存エラー。",
  "settings.penalty_questions.enabled": "ペナルティ質問を有効化",
  "settings.tab_advanced": "高度な設定",
  "settings.advanced_title": "高度な設定",
  "settings.penalty_questions": "質問ペナルティ設定",
  "settings.penalty_questions.header_parameter": " パラメーター",
  "settings.penalty_questions.header_value": "値",
  "settings.error_required": "このフィールドは必須です。",
  "settings.all_types": "すべての種類",
  "settings.select": "選択",
  "settings.edit": "編集",
  "settings.delete": "削除",
  "settings.tables": "テーブル",
  "settings.search_table": "テーブルを検索",
  "settings.no_tables": "利用可能なテーブルはありません",
  "settings.database": "データベース",
  "settings.host": "ホスト",
  "settings.port": "ポート",
  "settings.username": "ユーザー名",
  "settings.password": "パスワード",
  "settings.logo_help": "PNG または SVG 形式のロゴをアップロードしてください",
  "settings.logo_error": "ロゴのアップロードエラー",
  "settings.close": "閉じる",
  "settings.save_success": "設定が正常に保存されました",
  "settings.bc_email_label": "BCメール",
  "settings.db_delete_success": "DB接続は正常に削除されました",
  "settings.db_delete_error": "DB接続の削除エラー",
  "settings.select_tables": "テーブルを選択",
  "settings.whatsapp_title": "WhatsApp 設定",
  "settings.whatsapp_country_code": "国番号",
  "settings.whatsapp_country_code_placeholder": "国番号を入力",
  "settings.whatsapp_country_code_error": "有効な国番号を入力してください",
  "settings.whatsapp_number": "WhatsApp番号",
  "settings.whatsapp_number_error": "無効な番号です",
  "settings.whatsapp_invalid_number": "無効な番号です",
  "settings.whatsapp_invalid_reason_format": "形式が無効です",
  "settings.whatsapp_invalid_reason_possible": "選択した国では存在しない番号です",
  "settings.whatsapp_invalid_reason_valid": "有効な番号ではありません",
  "settings.whatsapp_save_btn": "保存",
  "settings.whatsapp_save_success": "WhatsApp番号が保存されました",
  "settings.whatsapp_save_error": "WhatsApp番号の保存エラー",
  "settings.whatsapp_update_success": "WhatsApp番号が更新されました",
  "settings.whatsapp_update_error": "WhatsApp番号の更新エラー",
  "settings.whatsapp_delete_btn": "削除",
  "settings.whatsapp_delete_success": "WhatsApp番号を削除しました",
  "settings.whatsapp_delete_error": "WhatsApp番号の削除エラー",
  "settings.whatsapp_edit_btn": "編集",
  "settings.whatsapp_configured_number": "設定済み番号:",
  "settings.tab_microsoft_integrations": "Microsoft integrations",
  "settings.reindex.title": "ドキュメントを再インデックス",
  "settings.reindex.description": "Home IA と Knowledge Hub 内のすべてのドキュメントを再処理します（再分類と知識抽出）。ルールを変更した場合や分析を更新したい場合に使用します。ファイルの再アップロードは行いません。",
  "settings.reindex.button": "ドキュメントを再インデックス",
  "settings.reindex.confirm": "はい、再インデックス",
  "settings.reindex.cancel": "キャンセル",
  "settings.reindex.error": "再インデックスを開始できませんでした。もう一度お試しください。",
  "settings.purge.title": "すべてのドキュメントを削除",
  "settings.purge.description": "すべてのドキュメント（ファイルを含む）、会話、分類、Home IA / Knowledge Hub のデータを完全に削除します。GoogleおよびMicrosoftアカウントの接続も解除され（トークンと同期データが削除されます）、再度同期するには再接続が必要になります。トークン使用履歴は保持されます。クリーンアップはバックグラウンドで実行され、完了時に通知が届きます。",
  "settings.purge.button": "すべてのドキュメントを削除",
  "settings.purge.confirm": "はい、すべて削除",
  "settings.purge.cancel": "キャンセル",
  "settings.purge.error": "クリーンアップを開始できませんでした。もう一度お試しください。",
};
